const reImage = /\.(jpg|gif|png|JPG|GIF|PNG|JPEG|jpeg)$/;
const reVideo = /\.(wmv|WMV|mpg|MPG|webm|WEBM|ogv|OGV|mob|MOV|asx|ASX|mpeg|MPEG|mp4|MP4|m4v|M4V|avi|AVI)$/;

export const isImage = (str) => reImage.test(str);
export const isVideo = (str) => reVideo.test(str);
